import axios from "@/plugins/axios";

let url = "/api/v1/partners";

export default {
    getPartners(data){
        return axios.get(url, data).then(result => result.data);
    },
    getPartner(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
}
